import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { TAB_MENU_SLIPS } from '../constants'
import { getOrdersByStatus } from '../Services/serviceAdmin'
import { getSlipsByStatus } from '../Services/servicePayment'
import { sortOrderByCreatedAt, alertError } from '../utils'
import Colors from '../../../constants/Colors'

const Tab = ({ tab, setTab, fetchOrdersByStatus, updateAllState }) => {
  const dispatch = useDispatch()

  const filterOrdersBySlips = (slips, orders) => {
    let data = []
    slips.forEach((s) => {
      orders.forEach((o) => {
        if (s.id === o.id) data.push(o)
      })
    })

    return data
  }

  const selectedTab = async (tabName) => {
    dispatch({ type: 'loading_show' })
    if (tabName === 'ALL') {
      fetchOrdersByStatus('CONFIRMED')
    } else {
      const confirm = await getOrdersByStatus('CONFIRMED', false)
      const slips = await getSlipsByStatus(tabName)
      const notIssue = confirm?.filter((v) => !v.isIssue)
      const allOrder = filterOrdersBySlips(slips, notIssue)

      if (allOrder?.length > 0) {
        allOrder.sort(sortOrderByCreatedAt)
        await updateAllState(allOrder)
      } else {
        alertError('ไม่พบข้อมูลออเดอร์')
      }
    }
    setTab(tabName)
    dispatch({ type: 'loading_hide' })
  }

  return (
    <>
      {TAB_MENU_SLIPS.map((name) => {
        return (
          <Container key={name} actived={tab === name} onClick={() => selectedTab(name)}>
            {name}
          </Container>
        )
      })}
    </>
  )
}

export default Tab

const Container = styled.div`
  flex: 1;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    color: ${Colors.ORANGE};
  }
  color: ${({ actived }) => actived && Colors.ORANGE};
`
